import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { MessagingRedesigned } from './messaging-redesigned';
import { IInjectedRootStore } from 'stores';

export function MessagingOutlet(props: IInjectedRootStore): React.ReactElement {
    return (
        <Routes>
            <Route path="" element={<MessagingRedesigned {...props} />} />
            <Route path="compose" element={<MessagingRedesigned {...props} />} />
            <Route path=":messageId" element={<MessagingRedesigned {...props} />} />
        </Routes>
    );
}

